module.exports = __webpack_public_path__ + "static/media/0096_Medium.4608b16b.jpg";